var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edurio-loading alert"},[_c('p',[_c('img',{attrs:{"src":"/material/img/ed-error.png","alt":"","height":"36"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }